var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.mode,{tag:"component",attrs:{"data":_vm.payload},on:{"goToDocument":function($event){return _vm.goToDocument($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }